import React, { useContext } from 'react';
import KickImage from 'Reuseables/KickImage';
import Title from '../../Atoms/Title';
import List from './Components/Organisms/List';

/** CSS import */
import Styles from './Fashion.module.scss';
import { GetDescriptionContext } from 'Pages/Blog/Context/Description';

const Fashion = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  const getDescriptionBySlug = useContext(GetDescriptionContext);
  
  return (
    <div className={Styles['wrapper']} ref={ref}>
      <div className={Styles['title-container']}>
        <Title text="Fashion" subTitle={getDescriptionBySlug('fashion')}/>
      </div>
      <List />
    </div>
  );
});

export default Fashion;
